import { render } from "./off_course_invoice_view.vue?vue&type=template&id=6e33f0f1"
import script from "./off_course_invoice_view.vue?vue&type=script&lang=js"
export * from "./off_course_invoice_view.vue?vue&type=script&lang=js"

import "./off_course_invoice_view.vue?vue&type=style&index=0&id=6e33f0f1&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__